/**
 * Auth Module
 * Core authentication module
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import type { Module } from '../../index';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';

const authModule: Module = {
  name: 'auth',
  path: '/auth',
  routes: [
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/signup',
      element: <Signup />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    }
  ]
};

export default authModule;

